/**
 * Convenience method to create a CustomEvent and dispatch it from the given element.
 * @param {Element} el - The element to dispatch the event from
 * @param {String} name - The name of the event
 * @param {*} detail - An object containing extended detail to pass with the event
 */
export default function dispatchCustomEvent(el, name, detail = {}) {
    const ev = new CustomEvent(name, { bubbles: true, cancelable: true, detail });
    el.dispatchEvent(ev);
    return ev;
}



// WEBPACK FOOTER //
// ./client/app/scripts/principles/events/dispatchCustomEvent.js